import { BaseRouteService } from 'core/services';

class CarrierServiceRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'carrier-services/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}
}

export default CarrierServiceRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/CarrierServiceRouteService.js